import { ComponentProps } from 'react';

export function Notebook({ ...props }: ComponentProps<'svg'>) {
  return (
    <svg
      {...props}
      width="30"
      height="32"
      viewBox="0 0 30 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26 0H8C5.79063 0 4 1.79063 4 4V6H1.5C0.671875 6 0 6.675 0 7.5C0 8.325 0.671875 9 1.5 9H4V14.5H1.5C0.671875 14.5 0 15.175 0 16C0 16.825 0.671875 17.5 1.5 17.5H4V23H1.5C0.671875 23 0 23.675 0 24.5C0 25.325 0.671875 26 1.5 26H4V28C4 30.2094 5.79063 32 8 32H26C28.2094 32 30 30.2094 30 28V4C30 1.79063 28.2062 0 26 0ZM7 28V26H8.5C9.33125 26 10 25.3312 10 24.5C10 23.6688 9.33125 23 8.5 23H7V17.5H8.5C9.33125 17.5 10 16.8312 10 16C10 15.1687 9.33125 14.5 8.5 14.5H7V9H8.5C9.33125 9 10 8.33125 10 7.5C10 6.66875 9.33125 6 8.5 6H7V4C7 3.44762 7.44775 3 8 3H12V29H8C7.45 29 7 28.55 7 28ZM27 28C27 28.5522 26.5522 29 26 29H15V3H26C26.5522 3 27 3.44762 27 4V28Z"
        fill="currentColor"
      />
    </svg>
  );
}
